<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" type="danger" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button>
          <el-dropdown v-if="tableAcl.indexOf('Print') != -1" @command="print">
            <el-button v-if="tableAcl.indexOf('Print') != -1" class="btn primary" type="primary">
              打印
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">打印</el-dropdown-item>
              <el-dropdown-item command="1">预览</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px;" @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @input="$forceUpdate()" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <div style="margin-bottom: 10px">
        <el-tabs v-model="query.orderStatus" @tab-click="tabClick" stretch>
          <el-tab-pane v-for="item in PurchaseDistributionStateArray" :key="item.id" :name="item.id + ''">
            <template slot="label">
              <el-badge :value="item.count" :max="99" class="item">
                <span style="margin: 0 10px"> {{ item.name }} </span>
              </el-badge>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
          <template slot="before">
            <el-table-column fixed :reserve-selection="true" type="selection" width="55" align="center"></el-table-column>
          </template>
          <template slot="after">
            <el-table-column v-if="query.orderStatus !=3" fixed="right" prop="operation" label="操作" width="180">
              <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
                <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
                <el-button v-else-if="
                    scope.row.status != 1 &&
                    scope.row.status != 2 &&
                    tableAcl.indexOf('Edit') != -1
                  " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
                <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
                <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
                <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
                <el-button v-if="tableAcl.indexOf('InStock') != -1 && (scope.row.distributionStatus == 4 || scope.row.distributionStatus == 1)" type="text" v-preventReClick @click="handleInStock(scope.row)" class="margin-left20 color-blue">入库</el-button>
                <el-button v-if="tableAcl.indexOf('BatchDistribution') != -1 && (scope.row.distributionStatus == 4 && scope.row.batchDistributionStatus != 1&&scope.row.isMergedOrder == 1)" type="text" v-preventReClick @click="distributeEvt(scope.row)" class="margin-left20 color-blue">入库并分发</el-button>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
     <div v-else>
      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column width="170" prop="no" label="验收单号">
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="80" prop="distributionStatusName" label="状态"></el-table-column>
        <el-table-column width="170" prop="orderNo" label="采购订单号"></el-table-column>

        <el-table-column width="120" prop="createdUserName" label="发起人"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间" min-width="170">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
          </template>
        </el-table-column>
        <el-table-column width="170" show-overflow-tooltip prop="supplierName" label="供应商"></el-table-column>
        <el-table-column min-width="150" show-overflow-tooltip prop="warehouseName" label="存放库房"></el-table-column>
        <!-- <el-table-column width="120" prop="deliveryTime" label="送货日期">
          <template slot-scope="scope">{{ parseTime(new Date(scope.row.deliveryTime), "{y}-{m}-{d}") }}</template>
        </el-table-column> -->
        <el-table-column width="120" prop="totalNumber" label="总数量"></el-table-column>
        <el-table-column width="120" prop="totalAmount" label="总金额"></el-table-column>
        <el-table-column  label="审批人" width="100" align="center" prop="approverNames">
          <template slot-scope="scope">
            <span>{{ scope.row.approverNames?scope.row.approverNames:'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="流程状态" width="80" >
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.remark?scope.row.remark:'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column width="170" prop="drmPurchaseDistributionNo" label="配送订单号"></el-table-column>
        <el-table-column fixed="right" width="80" prop="printingTimes" label="打印次数"></el-table-column>
        <el-table-column v-if="query.orderStatus !=3" fixed="right" prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
            <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
            <el-button v-else-if="
                scope.row.status != 1 &&
                scope.row.status != 2 &&
                scope.row.status != 4 &&
                tableAcl.indexOf('Edit') != -1
              " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
            <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2&& scope.row.status != 4" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
            <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
            <el-button v-if="tableAcl.indexOf('InStock') != -1 && (scope.row.distributionStatus == 4 || scope.row.distributionStatus == 1)" type="text" v-preventReClick @click="handleInStock(scope.row)" class="margin-left20 color-blue">入库</el-button>
            <el-button v-if="tableAcl.indexOf('BatchDistribution') != -1 && (scope.row.distributionStatus == 4 && scope.row.batchDistributionStatus != 1&&scope.row.isMergedOrder == 1)" type="text" v-preventReClick @click="distributeEvt(scope.row)" class="margin-left20 color-blue">入库并分发</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  

      <!-- <info :show="showInfo" :id="id" @handleClose="closeInfo"></info> -->
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>

    <el-dialog title="按科室一键分发" :visible.sync="distributeDialog" width="70%">
      <div>
        <div class="titleTop"> 
          <span>验收单号 : {{ distributeData.no }}</span>   <span>采购订单号 : {{ distributeData.orderNo }}</span>  <span>供应商 : {{ distributeData.supplierName }}</span>
        </div>
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">本次验收明细</span>
            </div>
            <el-table ref="childTable" border :data="distributeData.checkList" max-height="600" style="width: auto; margin: 0 10px; "  stripe :header-cell-style="{ background: '#DDEBFF' }"
            > 
              <el-table-column prop="supplierProductNo" label="供应商产品编码" min-width="180"></el-table-column>
              <el-table-column prop="productName" label="供应商产品名称" min-width="180" />
              <el-table-column show-overflow-tooltip prop="specName" label="产品规格" min-width="120" ></el-table-column>
              <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" min-width="120"></el-table-column>
              <el-table-column show-overflow-tooltip prop="number" label="本次验收数量" width="150" />

              <el-table-column prop="minUnit" label="最小单位" width="80"></el-table-column>
              <el-table-column prop="packSpec" label="包装规格" min-width="100">
              </el-table-column>
            </el-table>
          </div>

          <div class="edit-card">
            <div style="width: 88%; display: flex">
              <div class="start-label" />
              <span class="text">科室分发明细</span>
              </div>
              <el-tabs v-model="activeName" >
                   <el-tab-pane  v-for="(item,index) in distributeData.purchaseDistributionBatchDetailListViewModels" :key="item.index" :label="item.deptName" :name="index.toString()">
                  <el-table ref="childTable" border :data="item.distributionList" max-height="600" style="width: auto; margin:10px; " stripe  :header-cell-style="{ background: '#DDEBFF' }" :cell-class-name="cell"
                  > 
                    <el-table-column prop="supplierProductNo" label="供应商产品编码" min-width="180"></el-table-column>
                    <el-table-column prop="productName" label="供应商产品名称" min-width="180" />
                    <el-table-column show-overflow-tooltip prop="specName" label="产品规格" min-width="120" ></el-table-column>
                    <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" min-width="120"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="demandNumber" label="需求数量" min-width="150" />
                    <el-table-column show-overflow-tooltip prop="distributionNumber" label="分发数量" min-width="150">
                      <template slot-scope="scope">
                        <el-input-number v-model="scope.row.distributionNumber" size="small" @change="handleChange" :min="0" :max="scope.row.demandNumber"></el-input-number>
                      </template>
                    </el-table-column>
                    <el-table-column prop="minUnit" label="最小单位" width="80"></el-table-column>
                    <el-table-column prop="packSpec" label="包装规格" min-width="100">
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
            </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn primary" type="primary" v-preventReClick @click="distributeSubmit">确 定</el-button>
        <el-button class="btn default" v-preventReClick @click="distributeDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import Transfer from "@/components/transfer";
import {
  GetPurchaseDistributions,
  GetPurchaseDistributionPrintData,
  RemovePurchaseDistribution,
  GetBatchDistributionDetailByDistributionById,
  SavePurchaseDistributionBatch
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import BaseListMixin from "@/mixin/baseList-mixin.js";
// import Info from './info';
import {
  DistributionStateOptions,
  ApproveStatusOptions
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
    Transfer
  },
  data () {
    return {
      transferProps: [],
      GetDatasAction: GetPurchaseDistributions,
      RemoveAction: RemovePurchaseDistribution,
      PrintAction: GetPurchaseDistributionPrintData,
      editPath: "purchase-distribution-edit",
      // // 查询条件
      // query: {
      //   keyWord: "",
      //   pageSize: 10,
      //   pageIndex: 1,
      // },
      // // 列表数据
      // tableData: [],
      // // 列表总数
      // total: 0,
      // // 弹出框标题
      // title: "",
      // // 弹出编辑框
      // open: false,
      // // 打开详情
      // showInfo: false,
      // id: 0,
      // // 多选框数据
      // ids: [],
      // multipleSelection: [],
      // // 列表多选
      // multiple: true,
      DistributionStateOptions: DistributionStateOptions,
      ApproveStatusOptions: ApproveStatusOptions,
      filterOptions: [{
        name: "单号",
        type: "input",
        code: "keyWord",
      },
      {
        name: "供应商配送单号",
        type: "input",
        code: "drmPurchaseDistributionNo",
      },
      {
        name: "供货商产品",
        type: "select",
        code: "supplierProductId",
        filterMethod: this.getSupplierProductsNoDebounce,
        data: [],
      },
      {
        name: "供应商产品编码",
        type: "input",
        code: "supplierProductNo",
      },
      {
        name: "产品名称",
        type: "input",
        code: "productName",
      },
      {
        name: "规格型号",
        type: "input",
        code: "specName",
      },
      {
        name: "采购订单号",
        type: "input",
        code: "purchaseOrderNo",
      },
      // {
      //   name: "配送状态",
      //   type: "select",
      //   code: "orderStatus",
      //   data: DistributionStateOptions,
      // },
      {
        name: "供应商",
        type: "select",
        code: "supplierId",
        filterMethod: this.getSuppliers,
        data: [],
      },
      {
        name: "日期范围",
        type: "date",
        code: "date",
      },
      {
        name: "备注",
        type: "input",
        code: "remark",
      },
      {
        name: "流程状态",
        type: "select",
        code: "statuses",
        multiple: true,
        data: ApproveStatusOptions,
      },
      {
        name: "注册证号",
        type: "input",
        code: "productRegistCertNo",
      },
      {
        name: "主条码",
        type: "input",
        code: "mainNo",
      },
          {
            name: "二级供应商",
            type: "input",
            code: "secondSupplierName",
        },
      ],
      distributeDialog:false,
      distributeData:{},
      activeName:'0',
    };
  },
  methods: {

    tabClick () {
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      // this.$set(this.query, 'appId', id);
      this.getData();
    },
    cell({row, column, rowIndex, columnIndex}) {
      if(column.property == 'distributionNumber'){
        return 'red'
      }
      
      // if(row.)
    },
    handleInStock (row) {
      this.routePushWithParams("/accept-in-stock-edit", this.query, {
        formMode: 2,
        distributionId: row.id
      });
    },
    //
    distributeSubmit(){
      let arr = this.distributeData.purchaseDistributionBatchDetailListViewModels.flatMap(dept => dept.distributionList);
      console.log(arr);
      
      let check = false
      let product = []
      for (let item of  this.distributeData.checkList) {
        let arr1 = arr.filter(v=>item.productId==v.productId)
        let num = 0
        console.log(arr1);
        
        arr1.forEach(l=>{
            num+=l.distributionNumber
          })
          if( num > item.number){
            check = true
            item.extraNum = num
            product.push(item)
            break
          }
      }
      if(check){
        this.$my_message(`【${product[0].productName}】【${product[0].productName}】的总分发数量${product[0].extraNum}超过了验收数量${product[0].number}，请检查`, "warning");
        return
      }
      
      SavePurchaseDistributionBatch(this.distributeData).then(res=>{
        if(res.successful){
          this.$my_message(`执行成功`, "success");
          this.getData()
          this.activeName = '0'
          this.distributeDialog = false
        }
      })
    },
    handleChange(){
      this.$forceUpdate()
    },
    distributeEvt(row){
      GetBatchDistributionDetailByDistributionById({id:row.id}).then(res=>{
        if(res.successful){
          this.distributeData = res.returnData
          this.distributeDialog = true
        }
        
      })
    },
  },
  created () {
    this.query.orderStatus = "-1";

    // // 分页组件默认值需要早created
    if (this.$route.params) {
      this.query = this.$route.params
    }
  },
  mounted () {
    // // 查询组件默认值需要在mounted
    if (this.$route.params) {
      for (var property in this.$route.params) {
        this.$set(this.query, property, this.$route.params[property])
      }
      this.$refs["selectFilter"].query = Object.assign(this.$refs["selectFilter"].query, this.query)
    }
    if(this.$route.query.distributeId){
      this.distributeEvt({id:this.$route.query.distributeId})
      // this.distributeDialog = true
    }
    // this.getData();
  },
};
</script>

<style lang="scss" scoped>
// .el-tabs {
//   // margin-bottom: 10px;
// }
  .titleTop{
    margin: 10px 0;
    span{
      padding: 15px;
    }
  }
/deep/.red{
  background-color: rgba(255, 0, 0, 0.518) !important;
}
/deep/.el-badge__content.is-fixed {
  top: 10px !important;
  right: 16px !important;
}
/deep/.el-input-number--small{
  text-align: center !important;
}
/deep/.el-tabs--top .el-tabs__item.is-top:last-child,
.el-tabs--top .el-tabs__item.is-bottom:last-child,
.el-tabs--bottom .el-tabs__item.is-top:last-child,
.el-tabs--bottom .el-tabs__item.is-bottom:last-child {
  padding-right: 20px !important;
}
</style>
